import _ from 'underscore';
import { BaseAccountsSchemaProcessor } from './base-accounts-schema-processor';
import { initialize as initializeAvailableInsightTypeIds, updateEntitySchemaForAvailableInsightTypeIds, updateOdataOptionsForAvailableInsightTypeIds } from '../util/update-available-insight-type-ids-property-for-filter';

export class SmartPerformanceSchemaProcessor extends BaseAccountsSchemaProcessor {
  constructor(options) {
    const propWhitelist = _.compact([
      'Name',
      'Currency',
      'AccountType',
      'Owner',
      'BillToCustomerName',
      'Budget/DailyBudget',
    ]);

    initializeAvailableInsightTypeIds(options);
    super(options, { propWhitelist, allowBiPattern: true });
  }

  getOverridenSchemaProperties() {
    return {
      PerformanceMetricsAverageCPC: { filterable: false },
      PerformanceMetricsAverageCPM: { filterable: false },
      PerformanceMetricsTopImpressionRate: { filterable: false },
      PerformanceMetricsAbsoluteTopImpressionRate: { filterable: false },
      PerformanceMetricsAuctionWonPercent: { filterable: false },
      PerformanceMetricsAuctionLostToBudgetPercent: { filterable: false },
      PerformanceMetricsAuctionLostToRankPercent: { filterable: false },
      PerformanceMetricsAudienceAuctionWonPercent: { filterable: false },
      PerformanceMetricsAudienceTopISLostToBudgetPercent: { filterable: false },
      PerformanceMetricsAudienceTopISLostToRankPercent: { filterable: false },
      PerformanceMetricsClickSharePercent: { filterable: false },
      PerformanceMetricsExactMatchImpressionSharePercent: { filterable: false },
      PerformanceMetricsAbsoluteTopImpressionSharePercent: { filterable: false },
      PerformanceMetricsTopImpressionSharePercent: { filterable: false },
      PerformanceMetricsTopISLostToBudgetPercent: { filterable: false },
      PerformanceMetricsTopISLostToRankPercent: { filterable: false },
      PerformanceMetricsAbsoluteTopISLostToBudgetPercent: { filterable: false },
      PerformanceMetricsAbsoluteTopISLostToRankPercent: { filterable: false },
      PerformanceMetricsAllConversions: { filterable: false },
      PerformanceMetricsViewThroughConversions: { filterable: false },
      PerformanceMetricsViewThroughConversionsRevenue: { filterable: false },
      PerformanceMetricsViewThroughConversionsCPA: { filterable: false },
      PerformanceMetricsViewThroughConversionsReturnOnAdSpend: { filterable: false },
      PerformanceMetricsViewThroughConversionsRate: { filterable: false },
      PerformanceMetricsAllConversionCPA: { filterable: false },
      PerformanceMetricsAllConversionRate: { filterable: false },
      PerformanceMetricsAllConversionAdvertiserReportedRevenue: { filterable: false },
      PerformanceMetricsAllConversionRevenueOnAdSpend: { filterable: false },
      PerformanceMetricsRevenueOnAdSpend: { filterable: false },
      PerformanceMetricsAdvertiserReportedRevenue: { filterable: false },
    };
  }

  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = super.updateEntitySchemaForFeatures(entitySchema);
    updateEntitySchemaForAvailableInsightTypeIds(updatedSchema);
    return updatedSchema;
  }

  updateOdataOptions(odataOptions) {
    super.updateOdataOptions(odataOptions);
    updateOdataOptionsForAvailableInsightTypeIds(odataOptions);
    return odataOptions;
  }
}
